import MultiQueryPageLoader from '@/app/common/components/MultiQueryPageLoader'
import useGetSystemCatalogCategories from '@/queries/system_catalog/hooks/useGetSystemCatalogCategories'
import useGetSystemCatalogItems from '@/queries/system_catalog/hooks/useGetSystemCatalogItems'
import SystemCatalogView from './SystemCatalogView'

function SystemCatalogPage() {
  const { query: categoriesQuery, invalidateQuery: invalidateCategories } =
    useGetSystemCatalogCategories()

  const { query: itemsQuery, invalidateQuery: invalidateItems } =
    useGetSystemCatalogItems()

  return (
    <MultiQueryPageLoader
      showLoadingOnlyOnFirstFetch={true}
      queries={[categoriesQuery, itemsQuery] as const}
    >
      {([categories, items]) => {
        return (
          <SystemCatalogView
            categories={categories}
            items={items}
            invalidateCategories={invalidateCategories}
            invalidateItems={invalidateItems}
          />
        )
      }}
    </MultiQueryPageLoader>
  )
}

export default SystemCatalogPage
